import React from 'react'
import Highcharts from 'highcharts'
import more from 'highcharts/highcharts-more'
import HighchartsReact from 'highcharts-react-official'
Highcharts.seriesTypes.area.prototype.drawLegendSymbol =
  Highcharts.seriesTypes.line.prototype.drawLegendSymbol
const IDPChart = ({ chartType, chartOptions, height = 'inherit',width,chartRef  }) => {
  if (chartType === 'arearange') {
    if (typeof Highcharts === 'object') {
      more(Highcharts)
    }
  }

  return (
    <HighchartsReact
      containerProps={{
        style: {
          fontFamily: 'Optum Sans',
          height: height,
          width: width,
          position: 'relative',
          overflow:'scroll'
        },
      }}
      highcharts={Highcharts}
      options={chartOptions}
      allowChartUpdate
      updateArgs={[true, true, true]}
      ref={chartRef}
    />
  )
}

export default IDPChart
